import React from 'react';
import { BellIcon, XIcon } from 'lucide-react';
interface FirstLoginAlertProps {
  onDismiss: () => void;
  onShowModal: () => void;
}
const FirstLoginAlert: React.FC<FirstLoginAlertProps> = ({
  onDismiss,
  onShowModal
}) => {
  return <div className="bg-purple-50 border-l-4 border-purple-600 p-4 mb-6 flex justify-between items-center" data-id="element-117">
      <div className="flex items-center" data-id="element-118">
        <BellIcon size={20} className="text-purple-600 mr-2" data-id="element-119" />
        <div data-id="element-120">
          <p className="font-medium text-purple-800" data-id="element-121">
            Want help staying accountable?
          </p>
          <button onClick={onShowModal} className="text-sm text-purple-600 hover:text-purple-700 font-medium" data-id="element-122">
            Add a support buddy →
          </button>
        </div>
      </div>
      <button onClick={onDismiss} data-id="element-123">
        <XIcon size={20} className="text-purple-600" data-id="element-124" />
      </button>
    </div>;
};
export default FirstLoginAlert;